import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithEmailAndPassword,
         createUserWithEmailAndPassword, signOut, updateProfile } from 'firebase/auth';
import { getFirestore, doc, collection, addDoc, setDoc, getDoc, getDocs,
         query, orderBy, limit, serverTimestamp } from 'firebase/firestore';

// Firebase config — uses env vars in production, falls back for local dev
// NOTE: Firebase client keys are safe to expose (they're restricted by Firebase Security Rules
// and domain allowlists in the Firebase console). The real protection is Firestore rules,
// not key secrecy. Still, use env vars in production as best practice.
// Firebase config — values injected via Vercel environment variables at build time
// Never hardcode keys here — set them in Vercel Dashboard → Settings → Environment Variables
const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig, 'moodscope');
export const auth = getAuth(app);
export const db   = getFirestore(app);

const googleProvider = new GoogleAuthProvider();
export async function loginWithGoogle()              { return (await signInWithPopup(auth, googleProvider)).user; }
export async function loginWithEmail(e, p)           { return (await signInWithEmailAndPassword(auth, e, p)).user; }
export async function signupWithEmail(e, p, name)    { const r = await createUserWithEmailAndPassword(auth, e, p); if (name) await updateProfile(r.user, { displayName: name }); return r.user; }
export async function logout()                       { await signOut(auth); }

// ── Session storage ──────────────────────────────────────────────────────────
export async function createSession(uid, device) {
  const ref = await addDoc(
    collection(db, 'users', uid, 'moodscopeSessions'),
    { startTime: serverTimestamp(), device, endTime: null }
  );
  return ref.id;
}

export async function saveSnapshot(uid, sessionId, snapshot) {
  await addDoc(
    collection(db, 'users', uid, 'moodscopeSessions', sessionId, 'metrics'),
    snapshot
  );
}

export async function endSession(uid, sessionId) {
  await setDoc(
    doc(db, 'users', uid, 'moodscopeSessions', sessionId),
    { endTime: serverTimestamp() },
    { merge: true }
  );
}

export async function saveDailySummary(uid, dateStr, summary) {
  await setDoc(
    doc(db, 'users', uid, 'productivityDaily', dateStr),
    { ...summary, updatedAt: serverTimestamp() },
    { merge: true }
  );
}

// Fetches last N days of daily summaries for baseline computation
export async function fetchRecentDailySummaries(uid, days = 7) {
  try {
    const ref = collection(db, 'users', uid, 'productivityDaily');
    const q   = query(ref, orderBy('updatedAt', 'desc'), limit(days));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ date: d.id, ...d.data() }));
  } catch(e) {
    console.warn('fetchRecentDailySummaries failed:', e.message);
    return [];
  }
}
